module.exports = __webpack_public_path__ + "static/img/main_bg_black_en.c62c99f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/FreshCabinet/images/main_bg_black_en.jpg
// module id = 83ha
// module chunks = 1